var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _vm._l(_vm.supportedColumns[_vm.resource], function(col) {
        return _c("div", { key: col["field"] }, [
          _c("div", { staticClass: "detail" }, [
            _c("div", [
              _c("img", {
                staticClass: "filter-icon",
                class: [
                  { enabledCol: _vm.colEnabled(col["field"]) },
                  { disabledCol: !_vm.colEnabled(col["field"]) }
                ],
                attrs: {
                  width: "16px",
                  src: require("../../assets/filter_list_blue_24dp.svg")
                },
                on: {
                  click: function($event) {
                    return _vm.actionCol(
                      col["label"],
                      col["field"],
                      col["type"]
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("b", [_vm._v(_vm._s(col["label"]))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.fieldValue(
                      _vm.report,
                      _vm.resource,
                      _vm.selectedResource,
                      col["field"]
                    )
                  ) +
                  "\n        "
              )
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detail" },
        [
          _c("h6", [_vm._v("Tags")]),
          _vm._v(" "),
          _vm._l(
            _vm.report[_vm.resource][_vm.selectedResource]["Tags"],
            function(value, key) {
              return _c("div", { key: key, staticClass: "tags" }, [
                _c("div", { staticClass: "tag" }, [
                  _c("img", {
                    staticClass: "filter-icon",
                    class: [
                      { enabledCol: _vm.colEnabled("Tags." + key) },
                      { disabledCol: !_vm.colEnabled("Tags." + key) }
                    ],
                    attrs: {
                      width: "16px",
                      src: require("../../assets/filter_list_blue_24dp.svg")
                    },
                    on: {
                      click: function($event) {
                        return _vm.actionCol(key, "Tags." + key, "string")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(key))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "value" }, [
                  _vm._v("\n        " + _vm._s(value) + "\n      ")
                ])
              ])
            }
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d387790", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d387790","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/Details.vue
// module id = null
// module chunks = 